/**
 * Feature Flag Configuration
 * 
 * Controls feature availability for card-to-token functionality
 */

export interface CardToTokenConfig {
  enabled: boolean;
  useSimulator: boolean;
  simulatorPort: number;
  base24Host?: string;
  base24Port?: number;
}

const defaultConfig: CardToTokenConfig = {
  enabled: import.meta.env.VITE_CARD_TO_TOKEN_ENABLED === 'true',
  useSimulator: import.meta.env.VITE_BASE24_USE_SIMULATOR !== 'false', // Default to simulator
  simulatorPort: parseInt(import.meta.env.VITE_BASE24_SIMULATOR_PORT || '9999', 10),
  base24Host: import.meta.env.VITE_BASE24_HOST || 'localhost',
  base24Port: parseInt(import.meta.env.VITE_BASE24_PORT || '9999', 10),
};

let config: CardToTokenConfig = { ...defaultConfig };

/**
 * Get current configuration
 */
export function getCardToTokenConfig(): CardToTokenConfig {
  return { ...config };
}

/**
 * Update configuration
 */
export function setCardToTokenConfig(newConfig: Partial<CardToTokenConfig>): void {
  config = { ...config, ...newConfig };
}

/**
 * Check if card-to-token feature is enabled
 */
export function isCardToTokenEnabled(): boolean {
  return config.enabled;
}

/**
 * Check if simulator mode is enabled
 */
export function isSimulatorMode(): boolean {
  return config.useSimulator;
}

